import { identifyUserActionType } from '../../actionTypes';

const initialState = {
  authDetails: {},
  isAuthenticated: null,
  isGuest: null,
  isIdentified: null,
  isVerified: null,
  apiState: false,
  errorMessage: '',
};

const identifyUser = (state = initialState, action) => {
  switch (action.type) {
    case identifyUserActionType.IDENTIFY_USER_SUCCESS:
      const permissionsObj = {};
      const { permissions } = action.payload.data;
      permissions.map(
        (permission) => (permissionsObj[permission] = permission),
      );
      return {
        ...state,
        authDetails: action.payload.data.authDetails,
        isAuthenticated: permissionsObj['AUTHENTICATED'] ? true : false,
        isGuest:
          Object.keys(permissionsObj).length > 0 &&
          (permissionsObj['AUTHENTICATED'] ||
            permissionsObj['IDENTIFIED'] ||
            permissionsObj['VERIFIED'])
            ? false
            : true,
        isIdentified: permissionsObj['IDENTIFIED'] ? true : false,
        isVerified: permissionsObj['VERIFIED'] ? true : false,
        apiState: true,
      };
    case identifyUserActionType.IDENTIFY_USER_FAILURE:
      return {
        ...initialState,
        apiState: true,
        errorMessage: action.payload.errorMessage,
      };
    case identifyUserActionType.IDENTIFY_USER_AUTH_SET:
      return {
        ...state,
        isAuthenticated: true,
        isGuest: false,
        authDetails: { m: action.payload.mobile },
        isIdentified: true,
        isVerified: true,
      };
    case identifyUserActionType.IDENTIFY_USER_AUTH_RESET:
      return {
        ...state,
        authDetails: {},
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default identifyUser;



// WEBPACK FOOTER //
// ./reducer/identifyUser/index.js